import { Button } from '@anchor/react-components/dist/lib/components'
import React from 'react'

function ButtonGenerator({appearance, id, justifyItems, label, name, onClick, title, variant, style, disabled}) {

    return (
    <>
         <Button
         style={style}
            appearance={appearance}
            id={id}
            justifyItems={justifyItems}
            label={label}
            name={name}
            onClick={onClick}
            title={title}
            variant={variant}
            disabled={disabled}
          />
         
    </>
  )
}

export default ButtonGenerator